import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyAqVhdflAAhtqydR-IQmIaxxuQIwhnflRY",
  authDomain: "pdfdrive-b9b2b.firebaseapp.com",
  projectId: "pdfdrive-b9b2b",
  storageBucket: "pdfdrive-b9b2b.appspot.com",
  messagingSenderId: "358578323295",
  appId: "1:358578323295:web:19f357506463ee421340ea"
};
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const auth = firebase.auth();
  const storage = firebase.storage();
  const db = firebase.firestore();

  export { firebaseApp, auth, storage, db }